import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Translate, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IDriver } from 'app/shared/model/driver.model';
import { getEntity, updateEntity, createEntity, reset } from './driver.reducer';

export const DriverUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const driverEntity = useAppSelector(state => state.driver.entity);
  const loading = useAppSelector(state => state.driver.loading);
  const updating = useAppSelector(state => state.driver.updating);
  const updateSuccess = useAppSelector(state => state.driver.updateSuccess);

  const [formData, setFormData] = useState<any>({});
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleClose = () => {
    navigate('/driver' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
      setFormData({});
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (driverEntity) {
      setFormData({
        ...driverEntity,
      });
    }
  }, [driverEntity]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const handleChange = (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setFormData({ ...formData, [field]: value });
    if (errors[field]) {
      setErrors({ ...errors, [field]: '' });
    }
  };

  const validate = (): boolean => {
    const newErrors: Record<string, string> = {};
    if (!formData.name || formData.name.trim() === '') {
      newErrors.name = 'Name is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // eslint-disable-next-line complexity
  const saveEntity = () => {
    if (!validate()) {
      return;
    }

    const values = { ...formData };
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    if (values.age !== undefined && typeof values.age !== 'number') {
      values.age = Number(values.age);
    }

    values.enabled = values.enabled === true;

    const entity = {
      ...driverEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h2">
          <Translate contentKey="jhipsterSampleApplicationApp.driver.home.createOrEditLabel">Create or edit a Driver</Translate>
        </Typography>
      </Box>
      <Box component="form" sx={{ '& .MuiTextField-root': { mb: 2 } }} noValidate autoComplete="off">
        {loading ? (
          <Typography>Loading...</Typography>
        ) : (
          <Box>
            {!isNew && (
              <TextField
                label={translate('global.field.id')}
                id="driver-id"
                name="id"
                value={formData.id || ''}
                fullWidth
                InputProps={{ readOnly: true }}
                sx={{ mb: 2 }}
              />
            )}
            <TextField
              label={translate('jhipsterSampleApplicationApp.driver.name')}
              id="driver-name"
              name="name"
              data-cy="name"
              value={formData.name || ''}
              onChange={handleChange('name')}
              fullWidth
              required
              error={!!errors.name}
              helperText={errors.name || ''}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={formData.enabled || false}
                  onChange={handleChange('enabled')}
                  id="driver-enabled"
                  name="enabled"
                  data-cy="enabled"
                />
              }
              label={translate('jhipsterSampleApplicationApp.driver.enabled')}
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.driver.hiredAt')}
              id="driver-hiredAt"
              name="hiredAt"
              data-cy="hiredAt"
              value={formData.hiredAt || ''}
              onChange={handleChange('hiredAt')}
              fullWidth
              type="date"
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.driver.age')}
              id="driver-age"
              name="age"
              data-cy="age"
              value={formData.age || ''}
              onChange={handleChange('age')}
              fullWidth
              type="number"
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.driver.email')}
              id="driver-email"
              name="email"
              data-cy="email"
              value={formData.email || ''}
              onChange={handleChange('email')}
              fullWidth
              type="email"
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.driver.mobile')}
              id="driver-mobile"
              name="mobile"
              data-cy="mobile"
              value={formData.mobile || ''}
              onChange={handleChange('mobile')}
              fullWidth
            />
            <TextField
              label={translate('jhipsterSampleApplicationApp.driver.defaultImage')}
              id="driver-defaultImage"
              name="defaultImage"
              data-cy="defaultImage"
              value={formData.defaultImage || ''}
              onChange={handleChange('defaultImage')}
              fullWidth
            />
            <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
              <Button
                component={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/driver"
                replace
                color="info"
                variant="outlined"
                startIcon={<FontAwesomeIcon icon="arrow-left" />}
              >
                <Translate contentKey="entity.action.back">Back</Translate>
              </Button>
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                onClick={saveEntity}
                disabled={updating}
                variant="contained"
                startIcon={<FontAwesomeIcon icon="save" />}
              >
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default DriverUpdate;
